import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import { App } from './App';

/**
 * MSAL renews tokens by loading this origin in a hidden iframe and reading the
 * `#code=` Entra sends back. Booting the app in that iframe would run
 * handleRedirectPromise and consume the hash first, so the parent window waits
 * until it times out. Inside that iframe, render nothing and leave the URL alone.
 */
const inMsalFrame =
  window.self !== window.top && /(^|[#&])(code|error)=/.test(window.location.hash);

const container = document.getElementById('root');
if (!container) throw new Error('Root element not found');

if (!inMsalFrame) {
  createRoot(container).render(
    <StrictMode>
      <App />
    </StrictMode>,
  );
}
